var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",on:{"click":_vm.close}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""},on:{"click":function($event){$event.stopPropagation();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }